import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/athakai-cn/htdocs/cn.athakai.com/app/components/Comments.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/athakai-cn/htdocs/cn.athakai.com/app/components/Header.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/athakai-cn/htdocs/cn.athakai.com/app/components/SinglePostContent.js");
;
import(/* webpackMode: "eager" */ "/home/athakai-cn/htdocs/cn.athakai.com/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/athakai-cn/htdocs/cn.athakai.com/node_modules/next/dist/client/image-component.js");
